export class QuotationImportModel {
    counter: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    consecutive: number = 0;
    typeId: number = 0;
    conceptCodeConceptRejection: number | null = null;
    observationRejection: string | null = null;
    dateQuotation: Date = new Date();
    dateExpiration: Date = new Date();
    quotationStateId: number = 0;
    clientDocument: number | null = null;
    nameClient: string = "";
    constructionSiteCode: number | null = null;
    nameConstructionSite: string | null = null;
    sellerDocument: string = "";
    priceListCode: number | null = null;
    conceptCodeTypeEquipment: number = 0;
    mountingValue: number = 0;
    conceptCodeTypeBussiness1: number = 0;
    conceptCodeTypeBussiness2: number = 0;
    paymentMethod: string | null = null;
    deliveryTime: string | null = null;
    contact: string | null = null;
    phone1: string | null = null;
    phone2: string | null = null;
    addressConstructionSite: string | null = null;
    email: string | null = null;
    observation: string | null = null;
    observationCommercial: string | null = null;
    swConditions: boolean = false;
    showConsolidatedEquipmentAvailability: boolean = false;
    costCenterCode: number | null = null;
    solutionCode: string = "";
    solutionName: string | null = null;
    swBreakdown: boolean = false;
    baseValue: number = 0;
    unitCode: string = "";
    unitValueSolution: number | null = null;
    quantitySolution: number | null = null;
    subtotalValue: number | null = null;
    totalValue: number = 0;
    days: number = 0;
    ivaRate: number | null = null;
    ivaValue: number = 0;
    articleCode: number | null = null;
    unitValueBreakdown: number = 0;
    discountRateBreakdown: number = 0;
    clientValueBreakdown: number = 0;
    quantityBreakdown: number = 0;

    constructor(
        counter: number = 0,
        companyId: number = 0,
        branchId: number = 0,
        consecutive: number = 0,
        typeId: number = 0,
        conceptCodeConceptRejection: number | null = null,
        observationRejection: string | null = null,
        dateQuotation: Date = new Date(),
        dateExpiration: Date = new Date(),
        quotationStateId: number = 0,
        clientDocument: number | null = null,
        nameClient: string = "",
        constructionSiteCode: number | null = null,
        nameConstructionSite: string | null = null,
        sellerDocument: string = "",
        priceListCode: number | null = null,
        conceptCodeTypeEquipment: number = 0,
        mountingValue: number = 0,
        conceptCodeTypeBussiness1: number = 0,
        conceptCodeTypeBussiness2: number = 0,
        paymentMethod: string | null = null,
        deliveryTime: string | null = null,
        contact: string | null = null,
        phone1: string | null = null,
        phone2: string | null = null,
        addressConstructionSite: string | null = null,
        email: string | null = null,
        observation: string | null = null,
        observationCommercial: string | null = null,
        swConditions: boolean = false,
        showConsolidatedEquipmentAvailability: boolean = false,
        costCenterCode: number | null = null,
        solutionCode: string = "",
        solutionName: string | null = null,
        swBreakdown: boolean = false,
        baseValue: number = 0,
        unitCode: string = "",
        unitValueSolution: number | null = null,
        quantitySolution: number | null = null,
        subtotalValue: number | null = null,
        totalValue: number = 0,
        days: number = 0,
        ivaRate: number | null = null,
        ivaValue: number = 0,
        articleCode: number | null = null,
        unitValueBreakdown: number = 0,
        discountRateBreakdown: number = 0,
        clientValueBreakdown: number = 0,
        quantityBreakdown: number = 0
    ) {
        this.counter = counter;
        this.companyId = companyId;
        this.branchId = branchId;
        this.consecutive = consecutive;
        this.typeId = typeId;
        this.conceptCodeConceptRejection = conceptCodeConceptRejection;
        this.observationRejection = observationRejection;
        this.dateQuotation = dateQuotation;
        this.dateExpiration = dateExpiration;
        this.quotationStateId = quotationStateId;
        this.clientDocument = clientDocument;
        this.nameClient = nameClient;
        this.constructionSiteCode = constructionSiteCode;
        this.nameConstructionSite = nameConstructionSite;
        this.sellerDocument = sellerDocument;
        this.priceListCode = priceListCode;
        this.conceptCodeTypeEquipment = conceptCodeTypeEquipment;
        this.mountingValue = mountingValue;
        this.conceptCodeTypeBussiness1 = conceptCodeTypeBussiness1;
        this.conceptCodeTypeBussiness2 = conceptCodeTypeBussiness2;
        this.paymentMethod = paymentMethod;
        this.deliveryTime = deliveryTime;
        this.contact = contact;
        this.phone1 = phone1;
        this.phone2 = phone2;
        this.addressConstructionSite = addressConstructionSite;
        this.email = email;
        this.observation = observation;
        this.observationCommercial = observationCommercial;
        this.swConditions = swConditions;
        this.showConsolidatedEquipmentAvailability = showConsolidatedEquipmentAvailability;
        this.costCenterCode = costCenterCode;
        this.solutionCode = solutionCode;
        this.solutionName = solutionName;
        this.swBreakdown = swBreakdown;
        this.baseValue = baseValue;
        this.unitCode = unitCode;
        this.unitValueSolution = unitValueSolution;
        this.quantitySolution = quantitySolution;
        this.subtotalValue = subtotalValue;
        this.totalValue = totalValue;
        this.days = days;
        this.ivaRate = ivaRate;
        this.ivaValue = ivaValue;
        this.articleCode = articleCode;
        this.unitValueBreakdown = unitValueBreakdown;
        this.discountRateBreakdown = discountRateBreakdown;
        this.clientValueBreakdown = clientValueBreakdown;
        this.quantityBreakdown = quantityBreakdown;
    }
}